import React from 'react';
import './schdate.css';

const Schdate = ({ schdate, n1, n2, placetext }) => {
  return (
    <div className="eventcard re">

      {/* TOP ROW */}
      <div className="eventtop">
        <div className="time">{schdate}</div>

        <div className="place">
          <div className="dot"></div>
          <span>{placetext}</span>
        </div>
      </div>

      {/* MAIN INFO */}
      <div className="eventinfo">
        <h4 className="designer">{n1}</h4>
        <p className="collection">{n2}</p>
      </div>

      {/* ACTION */}
      <button className="bookbtn">BOOK NOW</button>

    </div>
  );
};

export default Schdate;